var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bg-blackly sm:p-2 focus:outline-none p-1",on:{"click":function($event){return _vm.$emit('click')}}},[_c('FullScreen',{staticClass:"hover:scale-110 w-full transform h-12"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }